"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AddHelpseekerDialogModule = /** @class */ (function () {
    function AddHelpseekerDialogModule() {
    }
    return AddHelpseekerDialogModule;
}());
exports.AddHelpseekerDialogModule = AddHelpseekerDialogModule;
